module.exports = __webpack_public_path__ + "img/bg2.b5fe2e97.png";